import { render, staticRenderFns } from "./RoomZoomRecord.vue?vue&type=template&id=2e624b65"
import script from "./RoomZoomRecord.vue?vue&type=script&lang=ts"
export * from "./RoomZoomRecord.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports